
import AllocateLcoomotive from "../../views/allocateLocomotive";
import LiveTrains from "../../views/LiveTrains/index";
import Login from "../../views/auth/Login";
import LocoMotiveList from "../../views/LocomotiveList/index"
import AddLocomotive from "../../views/addLocomotive/index"
import AllocationList from "../../views/AllocationList/index"
import Dashboard from "../../views/Dashboard/index";
import TrainList from "../../views/TrainList/index";
import AddTrain from "../../views/AddTrains/index";
import TrainRoute from "../../views/TrainRoute/index";
import AddTrainRoute from "../../views/AddTrainRoute/index";
import NotificationList from "../../views/NotificationList";
import AddNotification from "../../views/AddNotification";
import AddStation from "../../views/AddStation";
import StationList from "../../views/StationList";

const adminRoutes = [
 

  {
    path: "/dashboard",
    component: <Dashboard />,
  },
  {
    path: "/locomotive",
    component: <AllocateLcoomotive />,
  },
  {
    path: "/live-trains",
    component: <LiveTrains />,
  },
  {
    path: "/locomotive-list",
    component: <LocoMotiveList />,
  },
  {
    path: "/add-locomotive",
    component: <AddLocomotive />,
  },
  {
    path: "/allocation-list",
    component: <AllocationList />,
  },
  {
    path: "/train-list",
    component: <TrainList />,
  },
  {
    path: "/add-train",
    component: <AddTrain />,
  },
  {
    path: "/train-route",
    component: <TrainRoute />,
  },
  {
    path: "/addtrain-route",
    component: <AddTrainRoute />,
  },
  {
    path: "/notification",
    component: <NotificationList />,
  },
  {
    path: "/create-notification",
    component: <AddNotification />,
  },
  {
    path: "/add-station",
    component: <AddStation />,
  },
  {
    path: "/station-list",
    component: <StationList />,
  },

  // {
  //   path: "/login",
  //   component: <Login />,
  // },
  
];

export default adminRoutes;
